"use client";
import { Tag, Typography, Table } from "antd";

const { Text } = Typography;

const Preview = (props) => {
  const {
    formData,
    useCases,
    externalIdentifiers,
    customerSegmentOptions,
    transactionRestriction,
    productTypeEnum,
    statementCycleOptions,
    chargeTableSource,
  } = props;

  console.log(formData);

  const formatFullDate = (date) => {
    if (!date) return "-";
    try {
      return new Date(date).toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return "-";
    }
  };

  const columns = [
    [
      {
        key: " 1",
        title: "Name",
        dataIndex: "name",
      },
      {
        key: " 2",
        title: "Type",
        dataIndex: "type",
      },
      {
        key: " 3",
        title: "Amount",
        dataIndex: "amount",
      },
      {
        key: " 4",
        title: "Collected On",
        dataIndex: "collectedOn",
      },
    ],
  ];

  const channelAccessColumns = [
    {
      key: "1",
      title: "Channel",
      dataIndex: "channel",
    },
    {
      key: "2",
      title: "Transaction Limit",
      dataIndex: "transactionLimit",
      render: (value) => (value ? `₦ ${Number(value).toLocaleString()}` : "-"),
    },
    {
      key: "3",
      title: "Multi-Factor Auth",
      dataIndex: "multiFactorAuth",
      render: (value) => renderTag(value),
    },
  ];

  const ledgerAccountingColumns = [
    {
      title: "Field",
      dataIndex: "label",
      key: "label",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "GL Code",
      dataIndex: "value",
      key: "value",
    },
  ];

  const data = [
    {
      section: "Product Information",
      items: [
        {
          name: "Product Name",
          value: formData?.productInformation?.name
            ? formData.productInformation.name
            : "-",
        },
        {
          name: "Product Type",
          value:
            productTypeEnum?.[formData?.productInformation?.productTypeEnum]
              ?.label ||
            formData?.productInformation?.productTypeEnum?.value ||
            "-",
        },
        {
          name: "Currency Basic",
          value: formData?.productInformation?.currencyCode
            ? formData.productInformation.currencyCode
            : "-",
          isTag: true,
        },
        {
          name: "Use-case",
          value: (() => {
            if (
              !Array.isArray(formData?.productInformation?.useCases) ||
              formData.productInformation.useCases.length === 0
            ) {
              return "-";
            }
            return formData.productInformation.useCases.map((id) => {
              const match = useCases.find((opt) => opt.value === id);
              return match ? match?.label : String(id); // fallback to raw value
            });
          })(),
          isTagArray: true,
        },
        {
          name: "External Identifier",
          value:
            externalIdentifiers[formData?.productInformation?.externalIdEnum]
              ?.label ||
            externalIdentifiers[formData?.productInformation?.externalIdEnum]
              ?.value ||
            "-",
        },
        {
          name: "Activation Status",
          value: formData.productInformation?.activateWallet
            ? "Active"
            : "Inactive" ?? "-",
          isTag: true,
        },
        {
          name: "Allow Tokenization",
          value: formData.productInformation?.tokenisationEnabled ?? "-",
          isTag: true,
        },
        {
          name: "Minimum Sub Wallet",
          value: formData?.productInformation?.minSubwallet
            ? formData.productInformation.minSubwallet
            : "-",
        },
        {
          name: "Maximum Sub Wallet",
          value: formData?.productInformation?.maxSubwallet
            ? formData.productInformation.maxSubwallet
            : "-",
        },
        {
          name: "Start Date",
          value: formatFullDate(formData?.productInformation?.startDate),
        },
        {
          name: "End Date",
          value: formatFullDate(formData?.productInformation?.endDate),
        },
      ],
    },
    {
      section: "Customer Eligibility",
      items: [
        {
          name: "KYC Level",
          value: formData?.customerEligibility?.kycLevel
            ? formData.customerEligibility.kycLevel
            : "-",
          isTag: true,
        },
        {
          name: "Minimum Age",
          value:
            formData?.customerEligibility?.minimumAge + " years"
              ? formData.customerEligibility.minimumAge + " years"
              : "-",
        },
        {
          name: "Transaction Restriction",
          value: (() => {
            const selected =
              formData?.customerEligibility?.transactionRestriction;

            if (!Array.isArray(selected) || selected.length === 0) {
              console.log("ar");
              return "-";
            }

            return selected.map((id) => {
              const match = transactionRestriction.find(
                (opt) => opt.value === id
              );
              return match ? match?.label : String(id);
            });
          })(),
          isTagArray: true,
        },

        {
          name: "Customer Segment",
          value: (() => {
            const selected = formData?.customerEligibility?.customerSegment;

            if (!Array.isArray(selected) || selected.length === 0) {
              console.log("ar");
              return "-";
            }

            return selected.map((id) => {
              const match = customerSegmentOptions.find(
                (opt) => opt.value === id
              );
              return match ? match?.label : String(id);
            });
          })(),
          isTagArray: true,
        },
      ],
    },
    {
      section: "Account Parameters",
      items: [
        {
          name: "Maximum Wallet Balance",
          value: formData?.accountParameters?.maximumWalletBalance
            ? "₦ " +
              Number(
                formData.accountParameters.maximumWalletBalance
              ).toLocaleString()
            : "₦ -",
        },
        {
          name: "Daily Transaction Limit",
          value: formData?.accountParameters?.dailyTransactionLimit
            ? "₦ " +
              Number(
                formData.accountParameters.dailyTransactionLimit
              ).toLocaleString()
            : "₦ -",
        },
        {
          name: "Minimum Balance for Interest",
          value: formData?.accountParameters?.minBalanceForInterestCalculation
            ? "₦ " +
              Number(
                formData.accountParameters.minBalanceForInterestCalculation
              ).toLocaleString()
            : "₦ -",
        },
        {
          name: "Minimum Period for Interest",
          value:
            formData?.accountParameters?.lockinPeriodFrequency + " days"
              ? formData.accountParameters.lockinPeriodFrequency + " days"
              : "-" + " days",
        },
        {
          name: "Interest Bearing",
          value: formData.accountParameters?.interestBearing ?? "-",
          isTag: true,
        },
        {
          name: "Dormancy Period",
          value:
            formData?.accountParameters?.daysToDormancy + " Days"
              ? formData.accountParameters.daysToDormancy + " Days"
              : "-",
        },
        {
          name: "Statement Cycle",
          value: (() => {
            const selected = formData?.accountParameters?.statementCycle;

            if (!Array.isArray(selected) || selected.length === 0) {
              console.log("ar");
              return "-";
            }

            return selected.map((id) => {
              const match = statementCycleOptions.find(
                (opt) => opt.value === id
              );
              return match ? match?.label : String(id);
            });
          })(),
          isTagArray: true,
        },
      ],
    },
    {
      section: "Fees & Charges",
      items: [
        {
          isTable: true,
          dataSource: chargeTableSource, // your table data
          columns: columns[0],
        },
      ],
    },

    {
      section: "Channels & Access",
      table: true, // indicate it's a table-based section
      columns: channelAccessColumns,
      dataSource: formData?.channelsAndAccess ?? [],
    },
  ];

  const renderTag = (value) => {
    if (value === true) {
      return (
        <Tag
          style={{
            backgroundColor: "#ECFDF3",
            border: "1px solid #ABEFC6",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#067647",
              fontWeight: 600,
            }}
          >
            Yes
          </Text>
        </Tag>
      );
    }

    if (value === false) {
      return (
        <Tag
          style={{
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "16px",
            padding: "2px 12px",
            textTransform: "capitalize",
          }}
        >
          <Text
            style={{
              color: "#344054",
              fontWeight: 600,
            }}
          >
            No
          </Text>
        </Tag>
      );
    }

    if (
      value === "-" ||
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return <Text style={{ fontWeight: 500, color: "#6b7280" }}>-</Text>;
    }

    // Default tag for select fields
    return (
      <Tag
        style={{
          backgroundColor: "#FDF4FF",
          border: "1px solid #F6D0FE",
          borderRadius: "16px",
          padding: "2px 12px",
        }}
      >
        <Text
          style={{
            textTransform: "capitalize",
            color: "#9F1AB1",
            fontWeight: 600,
          }}
        >
          {value}
        </Text>
      </Tag>
    );
  };

  const renderRow = (item, index, section) => {
    const isLastItem = index === (data[section]?.items?.length || 0) - 1;

    if (item.isTable) {
      return (
        <div
          key={`table-section-${section}-${index}`}
          style={{
            padding: "16px 24px",
            backgroundColor: "#fff",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Table
            pagination={false}
            columns={item.columns}
            dataSource={item.dataSource}
            rowKey={(record, idx) => idx}
            bordered
            size="small"
          />
        </div>
      );
    }

    if (item.isInlineGroup && Array.isArray(item.group)) {
      return (
        <div
          key={`inline-group-${section}-${index}`}
          style={{
            display: "flex",
            borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
          }}
        >
          {item.group.map((fieldGroup, groupIndex) => (
            <>
              <div
                key={`group-${groupIndex}`}
                style={{
                  width: "50%",
                  backgroundColor: "#f9f9f9",
                  padding: "16px 24px",
                  fontWeight: "500",
                  borderRight: "1px solid #f0f0f0",
                }}
              >
                {fieldGroup.name}
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                  padding: "16px 24px",
                  width: "50%",
                  backgroundColor: "#fff",
                }}
              >
                {fieldGroup.fields.map((subField) => (
                  <div
                    key={subField.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: 500,
                    }}
                  >
                    {subField.isTag ? (
                      renderTag(subField.value)
                    ) : (
                      <span>{subField.value}</span>
                    )}
                  </div>
                ))}
              </div>
            </>
          ))}
        </div>
      );
    }

    return (
      <div
        key={item.key || item.name}
        style={{
          display: "flex",
          borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
        }}
      >
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#f9f9f9",
            fontWeight: "500",
            borderRight: "1px solid #f0f0f0",
          }}
        >
          {item.name}
        </div>
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#fff",
          }}
        >
          {item.isTagArray ? (
            Array.isArray(item.value) && item.value.length > 0 ? (
              <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                {item.value.map((val, i) => (
                  <div key={i}>{renderTag(val)}</div>
                ))}
              </div>
            ) : (
              <Text style={{ fontWeight: 500, color: "#6b7280" }}>-</Text>
            )
          ) : item.isTag ? (
            renderTag(item.value)
          ) : (
            <Text style={{ textTransform: "capitalize", fontWeight: 600 }}>
              {item.value || "-"}
            </Text>
          )}
        </div>
      </div>
    );
  };

  return (
    <div style={{ width: "100%" }}>
      <h1 style={{ fontSize: "24px", fontWeight: "700", margin: 0 }}>
        Preview
      </h1>
      <p
        style={{
          color: "#6b7280",
          fontWeight: "400",
          marginBottom: "24px",
          marginTop: 0,
        }}
      >
        Add description text to note for users
      </p>

      {data.map((section, sectionIndex) => (
        <div key={section.section}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              marginBottom: "16px",
            }}
          >
            {section.section}
          </h2>

          <div
            style={{
              border: "1px solid #f0f0f0",
              borderRadius: "8px",
              marginBottom: "24px",
              padding: section.table ? "16px" : "0", // optional: add padding for table section
            }}
          >
            {section.table ? (
              <Table
                columns={section.columns}
                dataSource={section.dataSource}
                pagination={false}
                rowKey={(record, index) => index}
              />
            ) : (
              section.items.map((item, index) =>
                renderRow(item, index, sectionIndex)
              )
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Preview;
